import { render, staticRenderFns } from "./addteam.vue?vue&type=template&id=abd97bb0&"
import script from "./addteam.vue?vue&type=script&lang=js&"
export * from "./addteam.vue?vue&type=script&lang=js&"
import style0 from "./addteam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports